import React from 'react';
import errorBoundary from '@ifeng/errorBoundary';
import Style from './index.css';

const Header = () => {
    return (
        <div className={Style.header}>
            <div className={Style.main}>
                <img className={Style.logo} src="http://x0.ifengimg.com/cmpp/2020/0310/6053b78b6d55866size3_w78_h50.jpg" alt="凤凰网" />
                <a href="https://www.ifeng.com/">返回首页 》</a>
            </div>
        </div>
    );
};

export default errorBoundary(Header);
